<app-header></app-header>
<div class="our_team">
  <div class="our_team_top text-center  bg_1 ">
    <ng-container *ngFor="let heading of head">
      <div class="inline_padding2" *ngIf="heading.page === currentPage">
        <div>
          <span class="text_style_5">Our Teams</span>
        </div>
        <div class="p-top-16">
          <span [innerHTML]="heading.page_sub_heading"></span>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="our_team_content  ">
    <ng-container *ngFor="let team of teams; let i = index">
      <!-- Card for even indexed items -->
      <div class="our_team_content_card1 bg_2 inline_padding1 " *ngIf="i % 2 === 0">
        <div class="our_team_content_card1_img">
          <div class="our_team_content_card1_img_bg">
            <img width="100%" height="100%" src="../../../assets/img/ourteams_bgimgyellow.webp" />
          </div>
          <img class="our_team_content_card1_img_profile border-radius-20"
            [src]="getMediaUrl(team.image, 'team-members')" width="100%" alt="{{ team.name }}">
        </div>
        <div class="our_team_content_card1_body ">
          <div class="our_team_content_card1_body_data">
            <div>
              <span class="text_black_7 text_align-justify"
                [innerHTML]="team.memberName || 'Name not available'"></span>
            </div>
            <div class="p-top-16" style="text-align: justify;">
              <div class="text_blue_7 text-wrap ql-editor description-wrapper"
                [innerHTML]="team.description || 'Description not available'"></div>
            </div>
            <div class="our_team_content_card1_body_data_icons p-top-16">
              <div>
                <a [href]="team.google_scholar" class="text_decoration_none" target="_blank">
                  <img src="../../../assets/icons/scholar_icon.png" />
                </a>
              </div>
              <div class="p-l-20">
                <a [href]="team.linkedInUrl" class="text_decoration_none" target="_blank">
                  <img src="../../../assets/icons/linkedin.png" />
                </a>
              </div>
            </div>
            <!-- <div class="p-top-16" *ngIf="team.web_link">
                            <span class="text_black_1">Weblink: </span>
                            <a [href]="team.web_link" class="text_blue_14" target="_blank">
                                {{ team.web_link }}
                            </a>
                        </div> -->
            <div class="p-top-12" style="display: flex; justify-content: flex-start;">
              <button type="button" class="rounded-pill text_white_1 button_blue_7"
                (click)="openLink(getMemberWebLink(team))"
                style="width: 150px; padding: 12px 24px; display: flex; justify-content: space-between; align-items: center; border: 0;">
                <span class="button_blue_1_text" style="font-size: 16px;">Weblink</span>
                <img class="button_blue_1_text_icon" src="../../../assets/icons/arrow-right.png"
                  style="height: 14px; max-width: none; object-fit: contain; margin-left: 10px;" />
              </button>
            </div>
            <div class="p-top-32">
              <span class="text_black_1">Biography</span>
            </div>
            <div class="text-wrap ql-editor description-wrapper"
              [ngClass]="{ 'text_lines_6': !showMore[i], 'p-top-16': true }"
              [innerHTML]="team.biography || 'Biography not available'"></div>
            <!-- <div class="cursor-pointer p-top-16">
                            <span class="text_blue_14" (click)="toggleShowMore(i)">
                                {{ showMore[i] ? 'Read Less' : 'Read More' }}
                            </span>
                        </div> -->
            <div class="cursor-pointer p-top-16" *ngIf="isDescriptionLong(team.biography)">
              <span class="text_blue_14" (click)="toggleShowMore(i)">
                {{ showMore[i] ? 'Read Less' : 'Read More' }}
              </span>
            </div>
            <div class="share-buttons" style="margin-top:15px;">
              <button (click)="copyLink()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fas fa-link" style="color: #000;"></i> <!-- Copy Link -->
              </button>
              <button (click)="shareViaEmail()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fas fa-envelope" style="color: #EA4335;"></i> <!-- Email -->
              </button>
              <button (click)="shareViaSMS()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fas fa-sms" style="color: #25D366;"></i> <!-- SMS -->
              </button>
              <button (click)="shareViaWhatsApp()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-whatsapp" style="color: #25D366;"></i> <!-- WhatsApp -->
              </button>
              <button (click)="shareViaMessenger()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-facebook-messenger" style="color: #0084FF;"></i> <!-- Messenger -->
              </button>
              <button (click)="shareViaViber()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-viber" style="color: #59267C;"></i> <!-- Viber -->
              </button>
              <button (click)="shareViaFacebook()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-facebook" style="color: #4267B2;"></i> <!-- Facebook -->
              </button>
              <button (click)="shareViaTwitter()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-twitter" style="color: #1DA1F2;"></i> <!-- Twitter -->
              </button>
              <button (click)="shareViaLinkedIn()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-linkedin" style="color: #0077B5;"></i> <!-- LinkedIn -->
              </button>
              <button (click)="shareViaPinterest()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-pinterest" style="color: #E60023;"></i> <!-- Pinterest -->
              </button>
              <button (click)="shareViaReddit()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-reddit" style="color: #FF4500;"></i> <!-- Reddit -->
              </button>
              <button (click)="shareViaTumblr()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-tumblr" style="color: #35465C;"></i> <!-- Tumblr -->
              </button>
              <button (click)="shareViaTelegram()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-telegram" style="color: #0088CC;"></i> <!-- Telegram -->
              </button>
              <button (click)="shareViaVK()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-vk" style="color: #4B7BE5;"></i> <!-- VK -->
              </button>
              <button (click)="shareViaMix()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-mix" style="color: #00A3E0;"></i> <!-- Mix -->
              </button>
              <button (click)="shareViaXing()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-xing" style="color: #006567;"></i> <!-- Xing -->
              </button>
              <button (click)="shareViaLine()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-line" style="color: #00B900;"></i> <!-- Line -->
              </button>

            </div>
          </div>
        </div>
      </div>

      <!-- Card for odd indexed items -->
      <div class="our_team_content_card2 bg_1 inline_padding1 " *ngIf="i % 2 !== 0">
        <div class="our_team_content_card2_body1">
          <div class="our_team_content_card2_img1">
            <!-- <img [src]="imageBaseUrl + team.image" class="img-fluid border-radius-20 our_teams_content_card2_img1" alt="{{ team.name }}"> -->
            <img [src]="team.image ? getMediaUrl(team.image, 'team-members') : 'assets/img/profile_dummy.png'"
              class="img-fluid border-radius-20 our_teams_content_card2_img1" alt="{{ team.name || 'No Name' }}">


          </div>
          <div class="our_team_content_card2_body1_data1">
            <div>
              <span class="text_black_7" [innerHTML]="team.memberName || 'Name not available'"></span>
            </div>
            <div class="p-top-16 text_align-justify">
              <div class="text_blue_7 text-wrap ql-editor description-wrapper"
                [innerHTML]="team.description || 'Description not available'"></div>
            </div>
            <div class="our_team_content_card2_body1_data1_icons1 p-top-16">
              <div>
                <a [href]="team.google_scholar" class="text_decoration_none" target="_blank">
                  <img src="../../../assets/icons/scholar_icon.png" />
                </a>
              </div>
              <div class="p-l-20">
                <a [href]="team.linkedInUrl" class="text_decoration_none" target="_blank">
                  <img src="../../../assets/icons/linkedin.png" />
                </a>
              </div>
            </div>
            <div class="p-top-12" style="display: flex; justify-content: flex-start;">
              <button type="button" class="rounded-pill text_white_1 button_blue_7"
                (click)="openLink(getMemberWebLink(team))"
                style="width: 150px; padding: 12px 24px; display: flex; justify-content: space-between; align-items: center; border: 0;">
                <span class="button_blue_1_text" style="font-size: 16px;">Weblink</span>
                <img class="button_blue_1_text_icon" src="../../../assets/icons/arrow-right.png"
                  style="height: 14px; max-width: none; object-fit: contain; margin-left: 10px;" />
              </button>
            </div>
            <div class="p-top-32" *ngIf="team.biography">
              <span class="text_black_1">Biography</span>
            </div>
            <div class="text-wrap ql-editor description-wrapper"
              [ngClass]="{ 'text_lines_6': !showMore[i], 'p-top-16': true }"
              [innerHTML]="team.biography || 'Biography not available'"></div>
            <!-- <div class="cursor-pointer p-top-16">
                            <span class="text_blue_14" (click)="toggleShowMore(i)">
                                {{ showMore[i] ? 'Read Less' : 'Read More' }}
                            </span>
                        </div> -->
            <div class="cursor-pointer p-top-16" *ngIf="isDescriptionLong(team.biography)">
              <span class="text_blue_14" (click)="toggleShowMore(i)">
                {{ showMore[i] ? 'Read Less' : 'Read More' }}
              </span>
            </div>
            <div class="share-buttons" style="margin-top:15px;">
              <button (click)="copyLink()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fas fa-link" style="color: #000;"></i> <!-- Copy Link -->
              </button>
              <button (click)="shareViaEmail()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fas fa-envelope" style="color: #EA4335;"></i> <!-- Email -->
              </button>
              <button (click)="shareViaSMS()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fas fa-sms" style="color: #25D366;"></i> <!-- SMS -->
              </button>
              <button (click)="shareViaWhatsApp()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-whatsapp" style="color: #25D366;"></i> <!-- WhatsApp -->
              </button>
              <button (click)="shareViaMessenger()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-facebook-messenger" style="color: #0084FF;"></i> <!-- Messenger -->
              </button>
              <button (click)="shareViaViber()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-viber" style="color: #59267C;"></i> <!-- Viber -->
              </button>
              <button (click)="shareViaFacebook()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-facebook" style="color: #4267B2;"></i> <!-- Facebook -->
              </button>
              <button (click)="shareViaTwitter()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-twitter" style="color: #1DA1F2;"></i> <!-- Twitter -->
              </button>
              <button (click)="shareViaLinkedIn()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-linkedin" style="color: #0077B5;"></i> <!-- LinkedIn -->
              </button>
              <button (click)="shareViaPinterest()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-pinterest" style="color: #E60023;"></i> <!-- Pinterest -->
              </button>
              <button (click)="shareViaReddit()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-reddit" style="color: #FF4500;"></i> <!-- Reddit -->
              </button>
              <button (click)="shareViaTumblr()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-tumblr" style="color: #35465C;"></i> <!-- Tumblr -->
              </button>
              <button (click)="shareViaTelegram()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-telegram" style="color: #0088CC;"></i> <!-- Telegram -->
              </button>
              <button (click)="shareViaVK()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-vk" style="color: #4B7BE5;"></i> <!-- VK -->
              </button>
              <button (click)="shareViaMix()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-mix" style="color: #00A3E0;"></i> <!-- Mix -->
              </button>
              <button (click)="shareViaXing()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-xing" style="color: #006567;"></i> <!-- Xing -->
              </button>
              <button (click)="shareViaLine()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-line" style="color: #00B900;"></i> <!-- Line -->
              </button>

            </div>
          </div>
        </div>
        <div class="our_team_content_card2_img">
          <div class="our_team_content_card2_img_bg">
            <img width="100%" height="100%" src="../../../assets/img/ourteams_bgimgblue.webp" />
          </div>
          <img [src]="getMediaUrl(team.image, 'team-members')"
            class="img-fluid border-radius-20 our_team_content_card2_img_profile" alt="{{ team.name }}">
        </div>
      </div>
    </ng-container>
  </div>

</div>
<app-footer></app-footer>